export default {
  getTravelAssistants: (state) => {
    return state.travelAssistants
  }
}
